export enum LegalRank {
	President = 'president',
	VicePresident = 'vicePresident',
	Secretary = 'secretary',
	DeputySecretary = 'deputySecretary',
	Treasurer = 'treasurer',
	DeputyTreasurer = 'deputyTreasurer',
	FirstPrincipalBoardMember = 'firstPrincipalBoardMember',
	SecondPrincipalBoardMember = 'secondPrincipalBoardMember',
	ThirdPrincipalBoardMember = 'thirdPrincipalBoardMember',
	FourthPrincipalBoardMember = 'fourthPrincipalBoardMember',
	FirstAlternateBoardMember = 'firstAlternateBoardMember',
	SecondAlternateBoardMember = 'secondAlternateBoardMember',
	ThirdAlternateBoardMember = 'thirdAlternateBoardMember',
	FourthAlternateBoardMember = 'fourthAlternateBoardMember',
	PrincipalAuditor = 'principalAuditor',
	AlternateAuditor = 'alternateAuditor',
	AdvisoryMember = 'advisoryMember',
}